

















































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import { Dialog } from "vant";
import EditSection from "@/components/modals/EditSection.vue";
import CKEditor from "ckeditor4-vue";
import axios from "axios";
import Questions from "@/components/cards/ConversationQuestions.vue";
import NewQuestions from "@/components/modals/NewQuestion.vue";

import { Notify } from "vant";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
    EditSection,
    Questions,
    NewQuestions,
  },
})
export default class Sections extends Vue {
  DivId: any = -1;
  show: any = false;
  editSectionIndex: any = -1;
  @Prop() Sections!: any;
  @Prop() Chapter!: any;
  MouseHover(DivId: any) {
    this.DivId = DivId;
  }
  MouseLeave(DivId: any) {
    this.DivId = -1;
  }
  showModal(index: any) {
    const modal_id = "modal_" + index;
    this.$refs[modal_id][0].showPopup();
  }
  showQuestionModal(index: any) {
    this.editSectionIndex = index;
    const modal_id = "new_modal_" + index;
    this.$refs[modal_id][0].showPopup();
  }

  DeleteSection(index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        const catId = this.$route.params.CategoryId;
        const passData = { category_id: catId, chapter: this.Chapter };
        this.$delete(this.Sections, index);
        const response = axios
          .post(
            "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/UpdateGrammarChapter",
            passData
          )
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Section is not Deleted" });
          });

        Notify({ type: "success", message: "Section is Deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }
  NewQuestion(question: any) {
    for (let i = 0; i < 4; i++) {
      if (question.answerIndices[i] == true) {
        question.answerIndices[i] = 1;
      } else question.answerIndices[i] = 0;
    }
    if (question.questionType == "TRANSLATE_REARRANGE")
      question.reorderAnswerList = question.reorderAnswerList.split(" ");

    this.Sections[this.editSectionIndex].questions.push({
      reorderShuffleList: [],

      imageUrl: question.imageUrl,
      questionTitle: question.questionTitle,
      questionType: question.questionType,
      reorderAnswerList: question.reorderAnswerList,
      answerId: question.answerId,
      answerOptions: question.answerOptions,
      answerIndices: question.answerIndices,
    });
    this.UpdateChapter();
    this.show = false;
    Notify({ type: "success", message: "Question added" });
    // chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    question.questionTitle = "";
    question.imageUrl = "";
    (question.questionType = ""), (question.answerOptions = ["", "", "", ""]);
    question.answerId = 0;
    question.answerIndices = [0, 0, 0, 0];
    question.reorderAnswerList = [];
  }

  UpdateChapter() {
    this.show = false;
    const catId = this.$route.params.CategoryId;
    const passData = { category_id: catId, chapter: this.Chapter };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/UpdateGrammarChapter",
        passData
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Grammar Chapter is not Updated" });
      });
    console.warn("rs", response);
    Notify({ type: "success", message: "Grammar Chapter Updated" });
    // const x = 10;
  }
}
